module.exports = __webpack_public_path__ + "static/media/gc-noir-solo.2acc913f.png";